module.exports = __webpack_public_path__ + "static/media/IMG_4387.af80fbfe.jpg";